const topics = [
  {
    title: '2024年最强国漫盘点',
    desc: '从斗罗大陆到完美世界，盘点本年度最受读者欢迎的十大国产漫画，部部精品不容错过。',
    tag: '盘点',
    img: 'https://readdy.ai/api/search-image?query=Collection%20of%20Chinese%20manhua%20covers%20arranged%20artistically%20in%20a%20grid%2C%20vibrant%20colors%20with%20martial%20arts%20and%20fantasy%20themes%2C%20warm%20coral%20and%20golden%20accents%2C%20clean%20editorial%20layout%20style%2C%20soft%20cream%20background%2C%20professional%20curated%20collection%20aesthetic&width=800&height=500&seq=carousel-01-guoman&orientation=landscape'
  },
  {
    title: '日漫经典重温专题',
    desc: '那些年追过的火影、海贼、死神，经典永不过时。带你重温热血青春时代的漫画记忆。',
    tag: '经典',
    img: 'https://readdy.ai/api/search-image?query=Nostalgic%20Japanese%20manga%20collection%20with%20warm%20sepia-like%20tones%2C%20classic%20shonen%20jump%20style%20characters%20in%20action%20poses%2C%20artistic%20collage%20arrangement%2C%20golden%20amber%20lighting%2C%20vintage%20editorial%20magazine%20layout%2C%20emotional%20atmosphere&width=800&height=500&seq=carousel-02-riman&orientation=landscape'
  },
  {
    title: '修仙漫画入门指南',
    desc: '从凡人修仙传到一念永恒，修仙题材漫画推荐与阅读顺序，新手也能快速入坑。',
    tag: '指南',
    img: 'https://readdy.ai/api/search-image?query=Mystical%20cultivation%20theme%20illustration%20with%20floating%20islands%20and%20ancient%20temples%2C%20Chinese%20xianxia%20aesthetic%2C%20flowing%20energy%20streams%20in%20coral%20and%20gold%20colors%2C%20epic%20panoramic%20composition%2C%20cinematic%20manga%20art%20style%2C%20soft%20cream%20background&width=800&height=500&seq=carousel-03-xiuxian&orientation=landscape'
  },
  {
    title: '下拉式阅读体验升级',
    desc: '告别传统翻页，全新下拉式阅读模式让你的漫画体验更加流畅沉浸，阅读速度提升三倍。',
    tag: '体验',
    img: 'https://readdy.ai/api/search-image?query=Modern%20digital%20manga%20reading%20interface%20on%20tablet%20device%2C%20vertical%20scroll%20webtoon%20style%20display%2C%20colorful%20comic%20panels%20flowing%20downward%2C%20warm%20ambient%20lighting%2C%20cozy%20reading%20environment%20with%20soft%20cream%20tones%2C%20lifestyle%20product%20photography%20vibe&width=800&height=500&seq=carousel-04-reading&orientation=landscape'
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">专题精选</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">深度专题内容，带你发现更多精彩漫画世界</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {topics.map((topic) => (
            <article key={topic.title} className="group cursor-pointer bg-background-50 rounded-xl overflow-hidden border border-background-200/70">
              <div className="relative aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={topic.img}
                  alt={`羞羞歪歪漫画专题 - ${topic.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-primary-500/90 text-background-50 text-xs font-medium">
                  {topic.tag}
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-base md:text-lg font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">{topic.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{topic.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}